import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Modal, Form } from 'react-bootstrap';
import { IoCloudUploadOutline } from "react-icons/io5";

import axios from '../../axios';
import apiError from '../../error';
import Loader from '../loader/loader';
import sampleFile from '../../assets/sample_remove_users_csv.csv';
import './rightside-modal.css';

export default class RemoveUsersCSVModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
        this.inputFile = React.createRef();
    }

    validateFileFormat = (e) => {
        const fileToRead = e.target.files[0];
        if (!fileToRead) {
            toast.error('No file selected.');
            return;
        }
        
        const reader = new FileReader();
        let error = false;
        
        reader.readAsText(fileToRead);
        reader.onload = (event) => {
            const csv = event.target.result;
            const allTextLines = csv.split(/\r\n|\n/);
            
            if (allTextLines.length <= 1) {
                toast.error('Empty CSV File Is Not Allowed');
            } else {
                const lines = allTextLines[0].split(',');
                
                if (lines.length !== 1 || lines[0].trim().toLowerCase() !== "email") {
                    error = true;
                }
                
                if (error) {
                    toast.error('Invalid CSV Format. Please ensure the file contains only an "email" column.');
                } else {
                    this.uploadFile(fileToRead); // Pass file directly
                }
            }
        };
        
        reader.onerror = () => {
            toast.error('Invalid File Received Or Something Went Wrong');
        };
    };
    

    uploadFile = (file) => {
        if (!file) {
            toast.error("No file found.");
            return;
        }
    
        const formData = new FormData();
        formData.append('file', file);
        this.setState({loading: true});
        
        axios.post(`/api/targets/remove-bulk-targets`, formData, {
            headers: {
                "Content-type": "multipart/form-data",
            }
        })
            .then((res) => {
                this.setState({loading: false});
                if(res.data.success){
                    this.props.removeUsers_CSVHandle();
                    this.props.fetchAllLocalTargets();
                    toast.success("Users deleted successfully");
                }else{
                    toast.error("Error file generated.")
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `bulkUserDeleteErr.csv`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
            .catch(err => {
                this.setState({loading: false});
                apiError(err);
            });
    };
    

    onButtonClick = () => {
        this.inputFile.current.click();
    };

    render() {
        return (
            <Modal className="info-filter right mainfooterModal creatGroupModal" show={this.props.removeUsers_showCSV} onHide={this.props.removeUsers_CSVHandle} autoFocus keyboard>
                <Modal.Header closeButton>
                    <div>
                        <h5>Bulk Remove Users</h5>
                        <p>Upload a CSV file containing emails of users to be removed.</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-md-12">
                        <div className="uploadBlock">
                            <IoCloudUploadOutline className="upload-icon" />
                            <h6>Select a CSV file to upload</h6>
                            <div className="emailAttachment">
                                <Form.Group>
                                    <Form.File id="fileUpload" accept=".csv" ref={this.inputFile} onChange={this.validateFileFormat} />
                                </Form.Group>
                            </div>
                            <hr style={{ width: '20%', margin: '5px auto', borderTop: '3px solid rgba(0, 0, 0, 0.1)' }} />
                            <div>
                                <a variant="link" className="blue-text" href={sampleFile}>Click here to download sample CSV file</a>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <div className="modalFooter">
                    <div className="row">
                        <div className="col-md-12 text-right">
                            <button type="button" className="btn closeBtn" onClick={this.props.removeUsers_CSVHandle}>Cancel</button>
                        </div>
                    </div>
                </div>
                {this.state.loading ? <Loader /> : null}
            </Modal>
        );
    }
}
